export interface ArticleMeta {
  slug: string;
  tagKey: string;
  titleKey: string;
  descKey: string;
  image: string;
}

export const articles: ArticleMeta[] = [
  {
    slug: 'usfans-spreadsheet-list',
    tagKey: 'tagResource',
    titleKey: 'aListTitle',
    descKey: 'aListDesc',
    image: 'https://readdy.ai/api/search-image?query=An%20overhead%20view%20of%20a%20neatly%20organized%20spreadsheet%20notebook%20with%20a%20laptop%20and%20coffee%20on%20a%20warm%20cream%20desk%2C%20sage%20green%20accents%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20workspace%20photography%2C%20fresh%20clean%20aesthetic%20with%20negative%20space&width=800&height=520&seq=art-list-01&orientation=landscape',
  },
  {
    slug: 'usfans-spreadsheet-links',
    tagKey: 'tagResource',
    titleKey: 'aLinksTitle',
    descKey: 'aLinksDesc',
    image: 'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20a%20smartphone%20and%20tablet%20displaying%20clean%20link%20icons%20on%20a%20warm%20cream%20desk%20with%20a%20small%20green%20plant%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20tech%20workspace%20photography%2C%20fresh%20clean%20aesthetic&width=800&height=520&seq=art-links-01&orientation=landscape',
  },
  {
    slug: 'usfans-review',
    tagKey: 'tagReview',
    titleKey: 'aReviewTitle',
    descKey: 'aReviewDesc',
    image: 'https://readdy.ai/api/search-image?query=A%20minimalist%20scene%20of%20a%20five%20star%20rating%20with%20a%20notebook%20and%20pen%20on%20a%20warm%20cream%20surface%2C%20soft%20sage%20and%20terracotta%20accents%2C%20gentle%20diffused%20daylight%2C%20editorial%20review%20concept%20photography%2C%20fresh%20clean%20aesthetic&width=800&height=520&seq=art-review-01&orientation=landscape',
  },
  {
    slug: 'is-usfans-legit',
    tagKey: 'tagLegit',
    titleKey: 'aLegitTitle',
    descKey: 'aLegitDesc',
    image: 'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20a%20person%20holding%20a%20smartphone%20showing%20a%20green%20verified%20checkmark%2C%20warm%20cream%20background%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20trust%20and%20safety%20concept%20photography%2C%20fresh%20clean%20aesthetic&width=800&height=520&seq=art-legit-01&orientation=landscape',
  },
  {
    slug: 'usfans-shipping-cost',
    tagKey: 'tagShipping',
    titleKey: 'aShippingTitle',
    descKey: 'aShippingDesc',
    image: 'https://readdy.ai/api/search-image?query=A%20small%20cardboard%20parcel%20box%20with%20kraft%20paper%20and%20a%20measuring%20tape%20on%20a%20warm%20cream%20surface%2C%20soft%20sage%20backdrop%2C%20gentle%20diffused%20daylight%2C%20editorial%20shipping%20and%20delivery%20concept%20photography%2C%20fresh%20clean%20aesthetic&width=800&height=520&seq=art-shipping-01&orientation=landscape',
  },
  {
    slug: 'usfans-warehouse-guide',
    tagKey: 'tagWarehouse',
    titleKey: 'aWarehouseTitle',
    descKey: 'aWarehouseDesc',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20organized%20warehouse%20shelf%20with%20neatly%20stacked%20boxes%20on%20a%20warm%20neutral%20background%2C%20soft%20diffused%20lighting%2C%20minimalist%20editorial%20logistics%20concept%20photography%2C%20fresh%20clean%20aesthetic%20with%20negative%20space&width=800&height=520&seq=art-warehouse-01&orientation=landscape',
  },
  {
    slug: 'usfans-qc-guide',
    tagKey: 'tagQc',
    titleKey: 'aQcTitle',
    descKey: 'aQcDesc',
    image: 'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20hands%20inspecting%20a%20white%20sneaker%20with%20a%20magnifying%20glass%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20quality%20check%20concept%20photography%2C%20fresh%20clean%20aesthetic&width=800&height=520&seq=art-qc-01&orientation=landscape',
  },
  {
    slug: 'usfans-coupon-discount',
    tagKey: 'tagCoupon',
    titleKey: 'aCouponTitle',
    descKey: 'aCouponDesc',
    image: 'https://readdy.ai/api/search-image?query=A%20minimal%20arrangement%20of%20a%20discount%20tag%20and%20scissors%20with%20a%20receipt%20on%20a%20warm%20cream%20surface%2C%20soft%20sage%20accents%2C%20gentle%20diffused%20daylight%2C%20editorial%20savings%20and%20coupon%20concept%20photography%2C%20fresh%20clean%20aesthetic&width=800&height=520&seq=art-coupon-01&orientation=landscape',
  },
  {
    slug: 'usfans-seller-guide',
    tagKey: 'tagSeller',
    titleKey: 'aSellerTitle',
    descKey: 'aSellerDesc',
    image: 'https://readdy.ai/api/search-image?query=A%20small%20storefront%20display%20with%20folded%20clothing%20and%20price%20tags%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20retail%20seller%20concept%20photography%2C%20fresh%20clean%20aesthetic&width=800&height=520&seq=art-seller-01&orientation=landscape',
  },
  {
    slug: 'usfans-safety-guide',
    tagKey: 'tagSafety',
    titleKey: 'aSafetyTitle',
    descKey: 'aSafetyDesc',
    image: 'https://readdy.ai/api/search-image?query=A%20minimal%20scene%20of%20a%20padlock%20and%20shield%20with%20a%20key%20on%20a%20warm%20cream%20surface%2C%20soft%20sage%20green%20backdrop%2C%20gentle%20diffused%20daylight%2C%20editorial%20online%20safety%20concept%20photography%2C%20fresh%20clean%20aesthetic&width=800&height=520&seq=art-safety-01&orientation=landscape',
  },
];